module.exports = "/images/laser tag (Union selection).svg?406946d7b0041fdb24f277b55cfabd89";